<template>
    <div id="department-chat-sidebar" v-if="!!selectedChat">
        <div class="head">
            <template>
                <a-dropdown :trigger="['click']">
                    <a class="ant-dropdown-link" @click.prevent>
                        <label class="imgUpload">
                            <a-avatar
                                id="department-summary-avatar"
                                v-if="
                                    groupProfilePicture || $_.get(selectedChat, 'meta.groupThread.groupProfilePicture')
                                "
                                :src="
                                    groupProfilePicture || $_.get(selectedChat, 'meta.groupThread.groupProfilePicture')
                                "
                                :size="84"
                            />
                            <!--                <a-avatar v-else icon="user" :size="84" />-->
                            <department-chat-icon v-else id="department-chat-icon" />
                        </label>
                    </a>
                    <template #overlay>
                        <a-menu id="dropdown-menu">
                            <a-menu-item class="menu-item" key="0">
                                <input
                                    id="change-pp"
                                    type="file"
                                    @change="uploadFile"
                                    accept="image/png, image/jpeg, image/gif"
                                />
                                <label
                                    for="change-pp"
                                    v-if="
                                        groupProfilePicture ||
                                        $_.get(selectedChat, 'meta.groupThread.groupProfilePicture')
                                    "
                                    ><a>{{ $t("message.changePhoto") }}</a></label
                                >
                                <label for="change-pp" v-else
                                    ><a>{{ $t("message.addPhoto") }}</a></label
                                >
                            </a-menu-item>
                            <a-menu-item
                                class="menu-item"
                                key="1"
                                v-if="
                                    groupProfilePicture || $_.get(selectedChat, 'meta.groupThread.groupProfilePicture')
                                "
                            >
                                <a @click="showViewer">{{ $t("message.seePhoto") }}</a>
                            </a-menu-item>
                            <a-menu-divider
                                v-if="
                                    groupProfilePicture || $_.get(selectedChat, 'meta.groupThread.groupProfilePicture')
                                "
                            />
                            <a-menu-item
                                v-if="
                                    groupProfilePicture || $_.get(selectedChat, 'meta.groupThread.groupProfilePicture')
                                "
                                id="delete-option"
                                class="menu-item"
                                key="2"
                                @click="deleteProfilePhoto"
                                >{{ $t("message.deletePhoto") }}
                            </a-menu-item>
                        </a-menu>
                    </template>
                </a-dropdown>
            </template>
            <a-modal id="groupViewerModal" :visible="isImageViewerShow" :footer="false" @cancel="closeViewer">
                <img :src="groupProfilePicture || $_.get(selectedChat, 'meta.groupThread.groupProfilePicture')" />
            </a-modal>
        </div>
        <div class="user-name">{{ getName(selectedChat) }}</div>
        <MediaSlide v-if="mediaSlideVisible" @close-media-slide="mediaSlideVisible = false" />

        <div class="user-info" v-else>
            <div class="media-row" @click="mediaSlideVisible = true">
                <span class="media-text"> {{ $t("message.sumChat_MediaFile") }}</span>
                <span class="material-icons media-btn">arrow_forward</span>
            </div>
            <span class="user-info-head">{{ $t("message.userInformations") }}</span>
            <!--Başlangıç-->
            <div v-if="onlineDepartmentUsers.length > 0" class="user-list">
                <p id="online-users-label">{{ $t("message.online") }}</p>
                <div v-for="departmentUser in onlineDepartmentUsers">
                    <div
                        class="department-user-info"
                        @click="departmentUser.userDetailVisible = !departmentUser.userDetailVisible"
                    >
                        <span class="department-user-item">
                            <div class="avatarContainer">
                                <AgentAvatar
                                    class="department-agents-avatar"
                                    :user-i-d="departmentUser._id"
                                    :size="30"
                                />
                            </div>
                            <div class="nameContainer">
                                <div class="tooltip-container" :title="departmentUser.name">
                                    {{ departmentUser.name }}
                                </div>
                            </div>
                        </span>
                        <span class="material-icons dm-message-btn" @click="directMessage(departmentUser)"
                            >message</span
                        >
                    </div>
                    <div v-if="departmentUser.userDetailVisible">
                        <div class="agent-item-detail" v-for="data in datas">
                            <span
                                class="material-icons"
                                id=""
                                style="color: #e7957f; font-size: 15px; max-width: 22px; margin-right: 5px"
                                >{{ data.icon }}</span
                            >
                            <span class="poped_datas" :title="data.slot === 'email' ? departmentUser[data.slot] : null">
                                {{ departmentUser[data.slot] }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <!--Bitiş-->
            <!--Başlangıç-->
            <div v-if="offlineDepartmentUsers.length > 0" class="user-list">
                <p id="offline-users-label">{{ $t("message.offline") }}</p>
                <div v-for="departmentUser in offlineDepartmentUsers">
                    <div
                        class="department-user-info"
                        @click="departmentUser.userDetailVisible = !departmentUser.userDetailVisible"
                    >
                        <span class="department-user-item">
                            <div class="avatarContainer">
                                <AgentAvatar
                                    class="department-agents-avatar"
                                    :user-i-d="departmentUser._id"
                                    :size="30"
                                />
                            </div>
                            <div class="nameContainer">
                                <div class="tooltip-container" :title="departmentUser.name">
                                    {{ departmentUser.name }}
                                </div>
                            </div>
                        </span>
                        <span class="material-icons dm-message-btn" @click="directMessage(departmentUser)"
                            >message</span
                        >
                    </div>
                    <div v-if="departmentUser.userDetailVisible">
                        <div class="agent-item-detail" v-for="data in datas">
                            <span
                                class="material-icons"
                                id=""
                                style="color: #e7957f; font-size: 15px; max-width: 22px; margin-right: 5px"
                                >{{ data.icon }}</span
                            >
                            <span class="poped_datas" :title="data.slot === 'email' ? departmentUser[data.slot] : null">
                                {{ departmentUser[data.slot] }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <!--Bitiş-->
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import MediaSlide from "./MediaSlide";
import CHAT_TYPES from "../../../utils/ChatTypes";
import Avatar from "vue-avatar";
import { sendSocketMessage } from "../../../utils/socketStream";
import { log2 } from "../../../utils/log2";
import { uploadAsset } from "../../../api/assetUpload";
import axios from "axios";
import departmentChatIcon from "../../../components/svg/DepartmentChatIcon";
import AgentAvatar from "../../../components/common/AgentAvatar.vue";

const log = log2("DepartmentSummaryChat");

export default {
    name: "DepartmentSummaryChat",
    components: { Avatar, MediaSlide, departmentChatIcon, AgentAvatar },
    props: {},
    data() {
        return {
            datas: [
                {
                    name: "Email",
                    slot: "email",
                    icon: "email",
                },
                {
                    name: "Ülke, Dil",
                    slot: "lang",
                    icon: "language",
                },
                {
                    name: "Platform",
                    slot: "lastLoginPlatform",
                    icon: "room",
                },
            ],
            departmentUsers: [],
            onlineDepartmentUsers: [],
            offlineDepartmentUsers: [],
            mediaSlideVisible: false,
            groupProfilePicture: null,
            isImageViewerShow: false,
        };
    },
    computed: {
        ...mapGetters({}),
        ...mapState({
            user: (state) => state.auth.user,
            users: (state) => state.user.users.data,
            selectedChat: (state) => state.team.selectedChat,
            site: (state) => state.site.site,
            chats: (state) => state.team.chats,
        }),
    },
    methods: {
        ...mapActions({
            selectedChatChange: "team/selectedChatChange",
            chatProfilePhotoUpdate: "team/chatProfilePhotoUpdate",
            chatProfilePhotoDelete: "team/chatProfilePhotoDelete",
        }),
        deleteProfilePhoto() {
            this.$dialog
                .confirm(this.$t("message.deletePhoto"), {
                    okText: this.$t("message.continue"),
                    cancelText: this.$t("message.cancel"),
                })
                .then(() => {
                    try {
                        this.$store.dispatch("team/groupProfilePicture", {
                            chatId: this.selectedChat._id,
                            groupProfilePicture: null,
                        });
                        this.$toasted.success(this.$t("message.successImgDelete"), {
                            duration: 1000,
                            position: "bottom-center",
                        });
                        this.groupProfilePicture = null;
                        this.chatProfilePhotoDelete({
                            chatId: this.selectedChat._id,
                            groupProfilePicture: null,
                        });
                    } catch (e) {
                        this.$toasted.error(this.$t("message.errorImgDelete"), {
                            duration: 1000,
                            position: "bottom-center",
                        });
                    }
                });
        },
        showViewer() {
            this.isImageViewerShow = true;
        },
        closeViewer() {
            this.isImageViewerShow = false;
        },
        directMessage(user) {
            const isDmChat = this.chats.filter((chat) => {
                if (chat.meta.chatType === CHAT_TYPES.THREAD) {
                    if (chat.meta.thread.agent1._id === user._id || chat.meta.thread.agent2._id === user._id) {
                        return chat;
                    }
                }
            });
            if (isDmChat.length > 0) {
                this.selectedChatChange(isDmChat[0]);
            } else {
                const thread = {
                    agent1: this.user._id,
                    agent2: user._id,
                };

                sendSocketMessage("team thread-chat-created", {
                    siteId: this.site._id,
                    thread,
                });
            }
        },
        getName(data) {
            if (data.meta.chatType === "groupThread") {
                return data.meta.groupThread.title;
            } else if (data.meta.chatType === "thread") {
                if (data.meta.thread.agent2 === this.user._id) {
                    return data.meta.thread.agent1.name;
                }
                return data.meta.thread.agent2.name;
            } else if (data.meta.chatType === "department") {
                return data.meta.department.languageContent[0].name;
            } else {
                return data.meta.chatType;
            }
        },
        getSlot(slot) {
            if (slot === "name") {
                if (this.selectedChat.meta.chatType === CHAT_TYPES.THREAD) {
                    if (this.selectedChat.meta.thread.agent1.name === this.user.name) {
                        return this.selectedChat.meta.thread.agent2.name;
                    } else {
                        return this.selectedChat.meta.thread.agent1.name;
                    }
                }
            }
        },
        uploadFile: async function (e) {
            const file = e.target.files[0];

            if (this.beforeUploadPicture(file)) {
                const path = `${this.site._id}/groupProfilePicture`;

                try {
                    const uploadData = await uploadAsset({
                        path,
                        mime: file.type,
                        name: file.name,
                        size: file.size,
                        type: "team-chat",
                    });
                    const timestamp = Date.now();
                    const newGroupProfilePicture = uploadData.data.asset.v2Format && uploadData.data.asset.cdnUrl
                        ? uploadData.data.asset.cdnUrl
                        : `https://static.supsis.live/${path + uploadData.data.asset._id}`;
                    this.$store.dispatch("team/groupProfilePicture", {
                        chatId: this.selectedChat._id,
                        groupProfilePicture: newGroupProfilePicture,
                    });

                    await axios({
                        method: uploadData.data.method,
                        url: uploadData.data.url,
                        data: file,
                        headers: { "Content-Type": "application/octet-stream" },
                    });

                    this.$toasted.success(this.$t("message.successImgUpload"), {
                        duration: 1000,
                        position: "bottom-center",
                    });

                    this.chatProfilePhotoUpdate({
                        chatId: this.selectedChat._id,
                        groupProfilePicture: newGroupProfilePicture,
                    });
                    this.groupProfilePicture = newGroupProfilePicture;
                } catch (e) {
                    this.$toasted.error(this.$t("message.errorImgUpload"), {
                        duration: 1000,
                        position: "bottom-center",
                    });
                }
            }
        },
        beforeUploadPicture(file) {
            const isJPG = file.type === "image/jpeg";
            const isPNG = file.type === "image/png";
            const isGIF = file.type === "image/gif";
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG && !isPNG && !isGIF) {
                this.$toasted.error(this.$t("message.errorImgUpload"), {
                    duration: 1000,
                    position: "bottom-center",
                });
                return false;
            }
            if (!isLt2M) {
                this.$toasted.error(this.$t("message.errorImgUpload"), {
                    duration: 1000,
                    position: "bottom-center",
                });
                return false;
            }
            return true;
        },
        onlineUserFilter() {
            this.onlineDepartmentUsers = [];
            this.offlineDepartmentUsers = [];
            this.departmentUsers.filter((user) => {
                if (user.isOnline) {
                    this.onlineDepartmentUsers.push(user);
                } else {
                    this.offlineDepartmentUsers.push(user);
                }
            });
        },
    },

    mounted() {
        if (!!this.selectedChat && !!this.selectedChat.meta && !!this.selectedChat.meta.department) {
            this.departmentUsers = this.users.filter((user) => {
                return user.subjects.includes(this.selectedChat.meta.department._id) || user.subjects.length === 0;
            });
            this.departmentUsers = this.departmentUsers.map((user) => {
                return {
                    ...user,
                    userDetailVisible: false,
                };
            });
            this.onlineUserFilter();
        }
    },

    watch: {
        selectedChat(newValue) {
            this.departmentUsers = this.users.filter((user) => {
                return user.subjects.includes(newValue.meta.department._id) || user.subjects.length === 0;
            });
            this.departmentUsers = this.departmentUsers.map((user) => {
                return {
                    ...user,
                    userDetailVisible: false,
                };
            });
            this.onlineUserFilter();
        },
    },
};
</script>

<style lang="scss">
#department-chat-sidebar {
    .tooltip-container {
        width: 100px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .head {
        display: flex;
        justify-content: center;
        padding: 10px;
        align-items: end;

        .user-segment-avatar {
            height: 55px;
            width: 55px;
            display: flex;
            align-items: center;
            font-size: 16px;
            background: #c4c4c4;
            border-radius: 50%;
            margin: 5px;
        }

        .user-active {
            height: 10px;
            width: 10px;
            background: green;
            border-radius: 50%;
            margin-bottom: 10px;
            margin-left: -16px;
        }
    }

    .user-name {
        font-size: initial;
        font-weight: 600;
        display: flex;
        justify-content: center;
    }

    .less-more {
        color: #ec4a1d;
        font-size: 20px;
        max-width: 22px;
        margin-right: 20px;
    }

    .user-type {
        font-size: initial;
        font-weight: 200;
        display: flex;
        justify-content: center;
    }

    .user-info {
        margin-top: 30px;
        margin-left: 20px;

        .media-row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 15px;
            cursor: pointer;

            .media-text {
                font-size: 17px;
                font-weight: 600;
                color: #9f8524;
            }

            .media-btn {
                color: #9f8524;
                font-size: 17px;
                max-width: 22px;
                margin-right: 35px;
                font-weight: 600;
            }
        }

        .department-user-info {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 10px;

            .department-user-item {
                display: flex;
                align-items: center;
                cursor: pointer;
                width: 75%;
                border-radius: 7px;
                padding: 3px;

                &:hover {
                    background: #ebebeb;
                }

                .avatarContainer {
                    width: 25%;
                }

                .nameContainer {
                    width: 45%;
                    font-weight: 600;
                }
            }

            .dm-message-btn {
                font-size: 20px;
                margin-right: 35px;
                cursor: pointer;
            }
        }

        .user-info-head {
            font-weight: 600;
            font-size: medium;
        }

        .agent-item-detail {
            display: flex;
            align-items: center;
            margin-left: 10px;
            margin-top: 5px;
        }

        .user-info-item {
            display: flex;
            margin-top: 20px;
            align-items: center;

            .info-right {
                margin-left: 10px;

                .info-name {
                    font-weight: 400;
                    font-size: smaller;
                    color: #c4c4c4;
                }

                .info-content {
                    font-weight: 400;
                }
            }
        }

        .poped_datas {
            width: 150px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }

    &::-webkit-scrollbar {
        display: none !important;
    }
}

#department-chat-icon {
    width: 85px;
    height: 85px;
    background-color: #d3d3d3;
    border-radius: 50%;
    display: grid;
    place-items: center;
}

.imgUploadOver {
    display: grid;
    place-items: center;
}

#department-summary-avatar {
    display: grid;
    place-items: center;
}

#dropdown-menu {
    background-color: #ffffff;

    a,
    label,
    input {
        color: #161616;
    }

    .menu-item {
        &:hover {
            background-color: #2196f3;

            a,
            label {
                color: #ffffff;
            }
        }

        #change-pp {
            display: none;
        }
    }

    #delete-option {
        color: #161616;

        &:hover {
            background-color: #f44336;
            color: #ffffff;
        }
    }
}

#groupViewerModal {
    .ant-modal {
        width: 52vw !important;
    }

    .ant-modal-close {
        .ant-modal-close-x {
            color: white;
            /*background: #434343;*/
            /*border-radius: 50%;*/
            position: absolute;
        }
    }

    .ant-modal-content {
        border-radius: 4px;
    }

    .ant-modal-body {
        padding: 0 !important;
    }

    img {
        width: 100%;
        height: 100%;
    }

    .ant-modal-mask {
        background-color: rgba(0, 0, 0, 0.75);
    }
}

.department-agents-avatar {
    position: relative;
    width: 30px;
    height: 30px;
    font-size: 14px !important;

    #avatar-img {
        border-radius: 50%;
        height: 30px !important;
        width: 30px !important;
        object-fit: cover;
    }

    #avatar-placeholder {
        border-radius: 50%;
        height: 30px !important;
        width: 30px !important;
        object-fit: cover;
        display: grid;
        place-items: center;

        span {
            font-size: 14px !important;
        }
    }

    #offline-dot {
        position: absolute;
        height: 25% !important;
        width: 25% !important;
        border-radius: 50%;
        background-color: #aeaeae;
        border: 0.5px solid white;
    }

    #online-dot {
        position: absolute;
        height: 25% !important;
        width: 25% !important;
        border-radius: 50%;
        background-color: #009900;
        border: 0.5px solid white;
    }
}
</style>
<style lang="scss" scoped>
.user-list {
    margin-top: 15px !important;
}

#online-users-label {
    font-size: 14px;
    font-weight: bold;
    color: #18752c;
}

#offline-users-label {
    font-size: 14px;
    font-weight: bold;
    color: #545454;
}
</style>
